import {createAction, props} from "@ngrx/store";
import {UserMap} from "@core/model/user-map";
import { FeatureCollection } from 'geojson';

export const ADD_NEW_DATACENTER = '[Map] Add new datacenter';
export const TOGGLE_MAP_ACTION = '[Map] Toggle aap action';

export const MAPBOX_MAP_LOADED = '[Map] Mapbox Map loaded';

export const LOAD_USER_MAP = '[Map] Load user map';
export const LOAD_USER_MAP_SUCCESS = '[Map] Load user map success';
export const LOAD_USER_MAP_FAILED = '[Map] Load user map failed';

export const SAVE_ORIGINAL_MARKERS = '[Map] Save Markers GeoJson';
export const TOGGLE_CLUSTER_MODE = '[Map] Toggle Cluster Mode';

export const mapboxMapLoaded = createAction(
  MAPBOX_MAP_LOADED,
)

export const loadUserMap = createAction(
  LOAD_USER_MAP,
  props<{ mapId: string, full: boolean }>()
)

export const loadUserMapSuccess = createAction(
  LOAD_USER_MAP_SUCCESS,
  props<{ userMap: UserMap }>()
)

export const loadUserMapFailed = createAction(
  LOAD_USER_MAP_FAILED,
  props<{ errorMsg: string }>()
)


export const addNewDatacenter = createAction(
  ADD_NEW_DATACENTER
);

export const toggleMapAction = createAction(
  TOGGLE_MAP_ACTION,
  props<{ mapAction: string }>()
);

export const saveOriginalMarkersGeoJson = createAction(
  SAVE_ORIGINAL_MARKERS,
  props<{ geoJson: FeatureCollection }>()
);

export const toggleClusterMode = createAction(
  TOGGLE_CLUSTER_MODE,
  props<{ cluster: boolean }>()
);
